// Telegram bot yönetimi Cloudflare Worker tarafından webhook üzerinden yapılıyor.
// Frontend token veya polling içermez.

import type { SensorReading, DeviceStatus, AlertEvent, CultivationStage, GrowBag, DailySummary, DeviceEvent } from '../types';

export interface BotSystemState {
  current:          SensorReading | null;
  devices:          DeviceStatus[];
  alerts:           AlertEvent[];
  activeStage:      CultivationStage;
  healthScore:      number | null;
  sensorConfidence: number | null;
  growBags:         GrowBag[];
  dailySummaries:   DailySummary[];
  deviceEvents:     DeviceEvent[];
}

// Bot durumu Supabase üzerinden Worker tarafından okunuyor — frontend'den güncellemeye gerek yok.
export function updateBotState(_state: BotSystemState): void {}

export async function startBotPolling(): Promise<void> {}
export function stopBotPolling(): void {}

// Worker'ın yapılandırılmış olup olmadığı SUPABASE_FUNCTIONS_URL varlığına göre belirlenir.
// Gerçek bot sağlık kontrolü Worker endpoint'inden yapılmalıdır.
export const botConfigured = typeof import.meta !== 'undefined'
  && !!(import.meta.env?.VITE_SUPABASE_FUNCTIONS_URL);
export const claudeConfigured = botConfigured;
